import React from 'react'
import SalesReportsListItem from './SalesReportsListItem'
 import { useTranslation } from 'react-i18next';

const SalesReportsList = ({data}) => {
      const [t, i18n] = useTranslation('global');
    return (
        <div className='m-5 rounded-lg bg-white border border-gray-200 sticky top-0 z-10'>
  <div className="grid grid-cols-12 gap-3 px-4 mt-2 bg-white font-bold text-[#251658] text-sm rounded-t-2xl justify-between items-center border-b py-4">
    <div className="text-center col-span-1">#</div>
    <div className="col-span-3">{t("reports.Product_Name")}</div>
    <div className="text-center col-span-1">{t("reports.Quantity")}</div>
    <div className="text-center col-span-2">{t("reports.Balance_Before")}</div>
    <div className="text-center col-span-2">{t("reports.Balance_After")}</div>
    <div className="text-center col-span-1">{t("reports.Source")}</div>
    <div className="text-center col-span-2">{t("reports.Date")}</div>
  </div>
  <div className='h-[calc(100vh-500px)] overflow-y-scroll custom-scrollbar'>
            {data.data.map((item, index) => (
                <SalesReportsListItem key={item.id} item={item} index={index}/>
            ))}
        </div>
        </div>
    )
}

export default SalesReportsList